import React from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ContentTraverserContext = React.createContext(
  null
);
const ContentTraverserContextProvider = ({
  nodeViewDecorators,
  renderers,
  SpoilerViewerWrapper,
  children
}) => {
  return /* @__PURE__ */ React.createElement(
    ContentTraverserContext.Provider,
    {
      value: { nodeViewDecorators, renderers, SpoilerViewerWrapper }
    },
    children
  );
};
const ContentTraverserContextConsumer = ({ children }) => /* @__PURE__ */ React.createElement(ContentTraverserContext.Consumer, null, (value) => children(value));
function withContentTraverserContext(Component) {
  return function(props) {
    return /* @__PURE__ */ React.createElement(ContentTraverserContext.Consumer, null, ({ nodeViewDecorators, renderers, SpoilerViewerWrapper }) => /* @__PURE__ */ React.createElement(
      Component,
      __spreadProps(__spreadValues({}, props), {
        nodeViewDecorators,
        renderers,
        SpoilerViewerWrapper
      })
    ));
  };
}

export { ContentTraverserContext, ContentTraverserContextConsumer, ContentTraverserContextProvider, withContentTraverserContext };
//# sourceMappingURL=ContentTraverserContext.js.map
